import { gql } from "graphql-request";

export const filteredSummary = gql`
  query filter($filterType: String!, $year: String!) {
    filteredSummary(filterType: $filterType, year: $year) {
      username
      totalTargetAmount
      totalAchievedAmount
      achievementPercentage
    }
  }
`;
export const allSalesTarget = gql`
  query {
    allSalesTarget {
      financialYear
    }
  }
`;

export const filterhalfyearly = gql`
query filterhalfyearly($filtertype:String!,$year:String!) {
  filteredSummary(filterType: $filtertype, year: $year) {
    username
    totalTargetAmount
    totalAchievedAmount
    achievementPercentage
  }
}
 `
 export const filtermonthly=gql`
  query filter($filterType: String!, $year: String!) {
    filteredSummary(filterType: $filterType, year: $year) {
      username
      targetAmount
      totalTargetAmount
      totalAchievedAmount
      achievementPercentage
    }
  }
 `